import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import firebaseConfig from "./firebaseConfig";
import LandingPage from "./components/LandingPage";
import Dashboard from "./components/index";

firebase.initializeApp(firebaseConfig);

export default function App() {
  const [user] = useAuthState(firebase.auth());
  

  return(
      <div>
        {!user ? (<LandingPage/>) : (<Dashboard/>)}
      </div>
  )
}
